import { useEffect, useState } from "react";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import usePageTracking from "../hooks/usePageTracking.js";
import Index from "../pages/landingPage/Index.jsx";
import LandingHome from "../pages/landingPage/home/index";
import AiCareerMentors from "../pages/landingPage/aiCareeerMentors/index.jsx";
import AiJobAssessment from "../pages/landingPage/aiJobAssessment/index.jsx";
import Community from "../pages/landingPage/community/index.jsx";
import Events from "../pages/landingPage/events/index.jsx";
import Jobs from "../pages/landingPage/jobs/index.jsx";
import Skilling from "../pages/landingPage/skilling/index.jsx";
import { FAQs } from "../pages/landingPage/faqs/index.jsx";
import { Pricing } from "../pages/landingPage/pricing/index.jsx";
import TermsOfService from "../pages/landingPage/termsOfService/index.jsx";
import PrivacyPolicy from "../pages/landingPage/privacypolicy/index.jsx";
import AuthLayout from "../components/AuthLayout/AuthLayout.js";
import SelectUser from "../pages/auth/selectUser/index.jsx";
import Login from "../pages/auth/login/login.jsx";
import Signup from "../pages/auth/signup/signup.jsx";
import ForgotPassword from "../pages/auth/forgotPassword/forgotPassword.jsx";
import OTPVerification from "../pages/auth/otpVerification/OtpVerification.jsx";
import NewPassword from "../pages/auth/newPassword/NewPassword.jsx";
import PasswordChanged from "../pages/auth/passwordChanged/PasswordChanged.jsx";
import ResendOtpComponent from "../pages/auth/resendOtp/resendOtp.jsx";
import Home from "../pages/dashboard/home/index.jsx";
import TestHomePages from "../pages/dashboard/home/TestHomePages.jsx";
import WelcomePage from "../pages/Welcome.jsx";
import Profile from "../pages/dashboard/profile/index.jsx";
import TaskAutomationAnalysis from "../pages/TaskAutomationAnalysis.jsx";
import AILiteracyAssessment from "../pages/AILiteracyAssessment.jsx";
import AiJobImpactAssesment from "../pages/AIJobImpactAssessment.jsx";
import CareerAssessmentLayout from "../components/CareerAssessment/CareerAssessmentLayout.jsx";
import CareerDiscoveryLayout from "../components/CareerDiscovery/CareerDiscoveryLayout.jsx";
import SkillsAndLearningLayout from "../components/SkillsAndLearning/SkillsAndLearningLayout.jsx";
import MentorsAndCommunityLayout from "../components/MentorsAndCommunity/MentorsAndCommunityLayout.jsx";
import JobSupportLayout from "../components/JobSupport/JobSupportLayout.jsx";
import HelpAndSupportLayout from "../components/HelpAndSupport/HelpAndSupportLayout.jsx";
import AiTalentPoolDashboard from "../pages/dashboard/aiTalentPool/index.jsx";
import CareerSelection from "../pages/dashboard/careerSelection/index.jsx";
import EmergingCareers from "../pages/EmergingCareers.jsx";
import MainstreamCareers from "../pages/MainstreamCareers.jsx";
import CareerRecommendations from "../pages/CareerRecommendations.jsx";
import MySavedCareers from "../pages/MySavedCareers.jsx";
import MySimulations from "../pages/dashboard/my-simulations/index.jsx";
import RecommendedCareer from "../pages/dashboard/recommendedCareer/index.jsx";
import RecommendedCourses from "../pages/dashboard/recommendedCourses/index.jsx";
import AISkillsLearningPage from "../pages/dashboard/aiSkillsLearning/index.jsx";
import QuizCompletePage from "../pages/dashboard/quizComplete/index.jsx";
import QuizCompletion from "../pages/dashboard/quizCompletion/index";
import AllCoursesHome from "../pages/dashboard/allCourses/index.jsx";
import AllJobs from "../pages/AllJobs.jsx";
import SavedJobs from "../pages/SavedJobs.jsx";
import AllMentors from "../pages/AllMentors.jsx";
import BookAppointmentPage from "../pages/dashboard/bookAppointmentPage/index.jsx";
import BookingSummary from "../pages/Mentor/BookingSummary.jsx";
import CheckoutPage from "../pages/dashboard/checkoutPage/index.jsx";
import MyAppointmentPage from "../pages/dashboard/myAppointmentPage/index.jsx";
import Subscription from "../pages/Subscription";
import CompleteSubscription from "../pages/dashboard/completeSubscription/index.jsx";
import GroupsDashboard from "../pages/dashboard/channelsDashboard/index.jsx";
import VirtualCoursesDashboard from "../pages/dashboard/virtualCoursesDashboard/index.jsx";
import GroupMentoringDashboard from "../pages/dashboard/groupMentoringDashboard/index.jsx";
import UserList from "../pages/Admin/UserList.jsx";
import ViewUserProfile from "../pages/Admin/ViewProfile.jsx";
import IncompleteUsers from "../pages/Admin/IncompleteUsersList.jsx";
import VoiceInterviewprepDashboard from "../pages/dashboard/voiceInterviewPrep/index.jsx";
import MyUpskillingPathway from "../pages/MyUpskillingPathway.jsx";
import UpskillingPathwayConfig from "../pages/UpskillingPathwayConfig.jsx";
import MySmartLearningHelper from "../pages/dashboard/smartLearningHelper/mySmartLearningHelper.jsx";
import CareerSimulationDashboard from "../pages/dashboard/careerSimulation/index.jsx";
import MockInterviewDashboard from "../pages/dashboard/mockInterview/index.jsx";
import MentorVerificationStatus from "../pages/dashboard/mentorVerificationStatus/MentorVerificationStatus.jsx";
import MentorProfileSettings from "../pages/dashboard/profileSettings/MentorProfileSettings.jsx";
import ReviewList from "../pages/dashboard/review/ReviewList.jsx";
import SheduleTimings from "../pages/dashboard/sheduleTime/SheduleTimings.jsx";
import SkillGapAnalysisToolPage from "../pages/SkillGapAnalysisTool.jsx";
import SupportPage from "../pages/Support.jsx";
import FaqComponent from "../pages/dashboard/faq/index.jsx";
import HelpUsPage from "../pages/dashboard/helpUsImprove/index.jsx";
import AdminDashboard from "../pages/Admin/AdminDashboard.jsx";
import ComplainDashboard from "../components/complainDashboard/index.jsx";
import ReportsDashboard from "../components/reportsDashboard/index.jsx";
import AILiteracyReport from "../components/aiLiteracyReport/index.jsx";
import JobAutomationReport from "../pages/Admin/JobAutomationReport.jsx";
import AdminGenderReport from "../components/adminGenderReport/index.jsx";
import ComingSoon from "../components/comingSoon/ComingSoon.jsx";
import MentorHome from "../pages/Mentor/MentorHome.jsx";
import MentorProfileInfo from "../components/profileInfo/MentorProfileInfo.jsx";
import MentorProfileView from "../components/forms/MentoProfileView.jsx";
import BankDetail from "../components/Bank Details/bankDetail.jsx";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute.jsx";
import SubscriptionGuard from "../components/SubscriptionGuard.jsx";
import MentorChatPage from "../pages/Mentor/MentorChatPage.jsx";
import MenteeChatPage from "../pages/Mentee/MenteeChatPage.jsx";
import ChatApp from "../pages/Community.jsx";
import CommunityPage from "../pages/Community.jsx";
import TermsAndConditionsPage from "../components/termsAndConditionsPage/index.jsx";
import RecommendedCoursesPage from "../components/recommendedCourses/index.jsx";
import LearningPathway from "../components/learningPathway/LearningPathway.jsx";
import LearningGrantsPage from "../components/learningGrants/index.jsx";
import MentorGroupsPage from "../components/mentorGroups/index.jsx";
import DocumentsList from "../components/resources/resources.jsx";
import CreateGroup from "../pages/Admin/CreateGroup.jsx";
import ListGroup from "../pages/Admin/ListGroup.jsx";
import CreateCourses from "../components/createCourses/CreateCourses.jsx";
import ListCourse from "../pages/Admin/ListCourse.jsx";
import CreateGroupMentoring from "../pages/Admin/CreateGroupMentoring.jsx";
import ListGroupMentor from "../pages/Admin/ListGroupMentor.jsx";
import Invoice from "../components/inVoice/InVoice.jsx";
import MentorsList from "../pages/Admin/MentorsList.jsx";
import MentorPricing from "../pages/Pricing/pricing.jsx";

const USER_TYPES = { ADMIN: "admin", MENTOR: "mentor", USER: "user" };
const SUBSCRIPTION_PLANS = { FREE: "free", PRO_MONTHLY: "pro-monthly", ONETIME: "onetime", PRO_YEARLY: "pro-yearly" };

const landingPageRoutes = [
  { path: "/", element: <LandingHome /> },
  { path: "/ai-job-assessment", element: <AiJobAssessment /> },
  { path: "/ai-career-mentors", element: <AiCareerMentors /> },
  { path: "/skilling", element: <Skilling /> },
  { path: "/community", element: <Community /> },
  { path: "/jobs", element: <Jobs /> },
  { path: "/events", element: <Events /> },
  { path: "/faqs", element: <FAQs /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/termsOfService", element: <TermsOfService /> },
  { path: "/privacyPolicy", element: <PrivacyPolicy /> },
];

const authRoutes = [
  { index: true, element: <SelectUser /> },
  { path: "login", element: <Login /> },
  { path: "signup", element: <Signup /> },
  { path: "forget", element: <ForgotPassword /> },
  { path: "otp", element: <OTPVerification /> },
  { path: "newpassword", element: <NewPassword /> },
  { path: "newpasswordsuccess", element: <PasswordChanged /> },
  { path: "resend-otp", element: <ResendOtpComponent /> },
];

const adminRoutes = [
  { path: "home", element: <AdminDashboard /> },
  { path: "users", element: <UserList /> },
  { path: "incomplete-profiles", element: <IncompleteUsers /> },
  { path: "users/:id", element: <ViewUserProfile /> },
  { path: "mentor", element: <MentorsList /> },
  { path: "mentor/:id", element: <MentorProfileView /> },
  { path: "community", element: <CommunityPage /> },
  { path: "reports", element: <ReportsDashboard />, children: [
    { path: "job-automation", element: <JobAutomationReport /> },
    { path: "ai-literacy-report", element: <AILiteracyReport /> },
    { path: "gender-report", element: <AdminGenderReport /> },
    { path: "categories-report", element: <ComingSoon /> },
  ]},
  { path: "complains", element: <ComplainDashboard /> },
  { path: "groups", element: <GroupsDashboard />, children: [
    { path: "create", element: <CreateGroup /> },
    { path: "create/:id", element: <CreateGroup /> },
    { path: "list", element: <ListGroup /> },
  ]},
  { path: "courses", element: <VirtualCoursesDashboard />, children: [
    { path: "create", element: <CreateCourses /> },
    { path: "create/:id", element: <CreateCourses /> },
    { path: "list", element: <ListCourse /> },
  ]},
  { path: "group-mentoring", element: <GroupMentoringDashboard />, children: [
    { path: "list", element: <ListGroupMentor /> },
    { path: "create", element: <CreateGroupMentoring /> },
    { path: "create/:id", element: <CreateGroupMentoring /> },
  ]},
];

const mentorRoutes = [
  { path: "account", element: <BankDetail /> },
  { path: "profile", element: <MentorProfileInfo /> },
  { path: "edit/:id", element: <MentorProfileInfo /> },
  { path: "home", element: <MentorHome /> },
  { path: "bookingsummary", element: <BookingSummary /> },
  { path: "resources", element: <DocumentsList /> },
  { path: "book-appointment/:userId", element: <BookAppointmentPage /> },
  { path: "sheduleTimings", element: <SheduleTimings /> },
  { path: "pricing", element: <MentorPricing /> },
  { path: "verification-status", element: <MentorVerificationStatus /> },
  { path: "profile-settings", element: <MentorProfileSettings /> },
  { path: "reviews", element: <ReviewList /> },
  { path: "chats-with-mentees", element: <MentorChatPage />},
  { path: "mentors-and-community", element: <MentorsAndCommunityLayout />, children: [
    { index: true, element: <Navigate to="/dashboard/mentors-and-community/mentorship" replace /> },
    { path: "mentorship", element: <AllMentors />, children: [
      { path: "groups", element: <MentorGroupsPage /> },
      { path: "chat", element: <ChatApp /> },
      { path: "appointments", element: <MyAppointmentPage />, children: [
        { path: "view-recipt", element: <Invoice /> },
      ]},
    ]},
    { path: "community", element: <CommunityPage /> },
    { path: "community/:id", element: <ChatApp /> },
  ]},
];

const PRO_PLANS = [SUBSCRIPTION_PLANS.PRO_MONTHLY, SUBSCRIPTION_PLANS.ONETIME, SUBSCRIPTION_PLANS.PRO_YEARLY];
const CHAT_PLANS = [SUBSCRIPTION_PLANS.PRO_YEARLY, SUBSCRIPTION_PLANS.PRO_MONTHLY];

const userRoutes = [
  { path: "welcome", element: <WelcomePage /> },
  { path: "home", element: <Home /> },
  { path: "test-home-pages", element: <TestHomePages /> },
  { path: "recommendedCourses", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><RecommendedCourses /></SubscriptionGuard> },
  { path: "profile", element: <Profile /> },
  { path: "career-assessment", element: <CareerAssessmentLayout />, children: [
    { index: true, element: <Navigate to="/dashboard/career-assessment/ai-job-impact-assessment" replace /> },
    { path: "ai-job-impact-assessment", element: <AiJobImpactAssesment /> },
    { path: "ai-literacy-assessment", element: <AILiteracyAssessment /> },
  ]},
  { path: "career-selection", element: <CareerSelection /> },
  { path: "task-automation-analysis", element: <TaskAutomationAnalysis /> },
  { path: "career-discovery", element: <CareerDiscoveryLayout />, children: [
    { index: true, element: <Navigate to="/dashboard/career-discovery/career-recommendations" replace /> },
    { path: "career-recommendations", element: <CareerRecommendations /> },
    { path: "career-simulation-tool", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><CareerSimulationDashboard /></SubscriptionGuard> },
    { path: "my-saved-careers", element: <MySavedCareers /> },
    { path: "my-simulations", element: <MySimulations /> },
  ]},
  { path: "ai-careers", element: <EmergingCareers /> },
  { path: "mainstream-careers", element: <MainstreamCareers /> },
  { path: "recommended-careers", element: <RecommendedCareer /> },
  { path: "ai-skills-learning", element: <AISkillsLearningPage /> },
  { path: "quiz-complete", element: <QuizCompletePage /> },
  { path: "help-and-support", element: <HelpAndSupportLayout />, children: [
    { index: true, element: <Navigate to="/dashboard/help-and-support/faq" replace /> },
    { path: "faq", element: <FaqComponent /> },
    { path: "help-us-improve", element: <HelpUsPage /> },
    { path: "update-subscription", element: <Subscription /> },
    { path: "support", element: <SupportPage /> },
  ]},
  { path: "complete-subscription", element: <CompleteSubscription /> },
  { path: "skills-and-learning", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><SkillsAndLearningLayout /></SubscriptionGuard>, children: [
    { index: true, element: <Navigate to="/dashboard/skills-and-learning/skill-gap-analysis-tool" replace /> },
    { path: "skill-gap-analysis-tool", element: <SkillGapAnalysisToolPage /> },
    { path: "recommended-courses", element: <RecommendedCoursesPage /> },
    { path: "my-courses", element: <LearningPathway /> },
    { path: "learning-grants", element: <LearningGrantsPage /> },
    { path: "my-smart-learning-helper", element: <MySmartLearningHelper /> },
    { path: "my-upskilling-pathway", element: <MyUpskillingPathway /> },
    { path: "upskilling-pathway-config", element: <UpskillingPathwayConfig /> },
    { path: "all-courses", element: <AllCoursesHome /> },
  ]},
  { path: "job-support", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><JobSupportLayout /></SubscriptionGuard>, children: [
    { index: true, element: <Navigate to="/dashboard/job-support/jobs" replace /> },
    { path: "jobs", element: <AllJobs />, children: [
      { path: "explore-jobs", element: <AllJobs /> },
      { path: "voice-interview-prep", element: <VoiceInterviewprepDashboard /> },
    ]},
    { path: "saved-jobs", element: <SavedJobs /> },
    { path: "ai-talent-pool", element: <AiTalentPoolDashboard /> },
    { path: "mock-interview", element: <MockInterviewDashboard /> },
  ]},
  { path: "mentors-and-community", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><MentorsAndCommunityLayout /></SubscriptionGuard>, children: [
    { index: true, element: <Navigate to="/dashboard/mentors-and-community/mentorship" replace /> },
    { path: "mentorship", element: <AllMentors />, children: [
      { path: "groups", element: <MentorGroupsPage /> },
      { path: "chat", element: <ChatApp /> },
      { path: "appointments", element: <MyAppointmentPage />, children: [
        { path: "view-recipt", element: <Invoice /> },
      ]},
    ]},
    { path: "community", element: <CommunityPage /> },
    { path: "community/:id", element: <ChatApp /> },
  ]},
  { path: "chat", element: <SubscriptionGuard allowedPlans={CHAT_PLANS}><ChatApp /></SubscriptionGuard> },
  { path: "chat/:id", element: <SubscriptionGuard allowedPlans={CHAT_PLANS}><ChatApp /></SubscriptionGuard> },
  { path: "chats-with-mentors", element: <SubscriptionGuard allowedPlans={CHAT_PLANS}><MenteeChatPage /></SubscriptionGuard> },
  { path: "book-appointment/:userId", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><BookAppointmentPage /></SubscriptionGuard> },
  { path: "checkout", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><CheckoutPage /></SubscriptionGuard> },
  { path: "quizCompletion", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><QuizCompletion /></SubscriptionGuard> },
  { path: "terms-and-conditions", element: <SubscriptionGuard allowedPlans={PRO_PLANS}><TermsAndConditionsPage /></SubscriptionGuard> },
];

const PageTracker = () => { usePageTracking(); return <Outlet />; };

const AppRoutes = () => {
  const [userType, setUserType] = useState(localStorage.getItem("userType"));
  useEffect(() => {
    const handleStorageChange = () => setUserType(localStorage.getItem("userType"));
    window.addEventListener("accessTokenChanged", handleStorageChange);
    return () => window.removeEventListener("accessTokenChanged", handleStorageChange);
  }, []);

  const getDashboardRoutes = () => {
    switch (userType) {
      case USER_TYPES.ADMIN: return adminRoutes;
      case USER_TYPES.MENTOR: return mentorRoutes;
      case USER_TYPES.USER: return userRoutes;
      default: return [];
    }
  };

  return createBrowserRouter([{
    element: <PageTracker />,
    children: [
      { path: "/", element: <Index />, errorElement: <>Error Page</>, children: landingPageRoutes },
      { path: "/auth", element: <AuthLayout />, children: authRoutes },
      { path: "/dashboard", element: <ProtectedRoute />, children: getDashboardRoutes() },
      { path: "*", element: userType ? <Navigate to="/dashboard/home" replace /> : <Navigate to="/auth/login" replace /> }
    ],
  }]);
};

export default AppRoutes;
